export function info() {
    document.addEventListener("DOMContentLoaded", function() {

    function handleOpenButtonClick() {
        const infoPopup = document.querySelector('.info-popup'); 

        const body = document.querySelector('body');
    
        if (infoPopup) {
            infoPopup.classList.add('visible');
            // updateRightDivHeight();
            console.log('.info-popup is now visible.');
        } else {
            console.error('.info-popup not found.');
        }
    
        body.classList.add('popup-open');
        console.log('Body now has the class "popup-open".');
    }

    function closeClick() {
        const infoPopup = document.querySelector('.info-popup'); 
        const body = document.querySelector('body');
    
        if (infoPopup) {
            infoPopup.classList.remove('visible');
            body.classList.remove('popup-open');
        } else {
            console.error('.exit-popup not found.');
        }
    
        console.log('Button inside .exit-popup clicked.');
    }
    
    const openButton = document.querySelector('.open-info'); 
    if (openButton) {
        openButton.addEventListener('click', function() {
            console.log('Open button clicked.');
            handleOpenButtonClick(); 
        });
    } else {
        console.error('.open-info not found.');
    }

    const closeInfoPopup = document.querySelectorAll('.close-info'); 

    closeInfoPopup.forEach(button => {
        button.addEventListener('click', function(event) {
            closeClick(); 
        });
    });



}
);}
